<template>
  <div class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-1"><router-link  to="/">{{$t("addAd.breadcrumb_1")}}</router-link></li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="mx-1 breadcrumb-title">
          <router-link to="/propertiecreate">
            {{$t("addAd.advertisingLicense")}}
          </router-link>
        </li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="mx-1 active" aria-current="page">
          {{$t("addAd.applicationAdvertisingLicense")}}
        </li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col">
            <errorAlert v-if="hasError" :alertMessage="message" 
            :errorNumber="errorNumber" 
          />
          </div>
        </div>
        <div v-if="loading" class="row justify-content-center">
          <div class="col text-center">
            <mainloader />
          </div>
        </div>
        <div class="row justify-content-center pt-3">
          <div class="col-12 col-md-8">
            <div class="row">
              <div class="col-12 col-md-6">
                <label for="" class="p-content" >{{$t('addAd.landRegistry_number')}}</label>
                <input type="text" v-model="deedNumber" maxlength="16" @input="deedNumber = deedNumber.replace(/[^0-9]/g, '')"
                  class="form-control input-style" :placeholder="$t('addAd.deedNumber')">
                  <div class="error-feedback" v-if="V$.deedNumber.$error">
                    {{ validateMessage }}
                  </div>
              </div>
              <div class="col-12 col-md-6">
                <label for="" class="p-content" >{{$t('addAd.owner_Agent')}}</label>
                <input type="text" v-model="identityNumber" maxlength="10" @input="identityNumber = identityNumber.replace(/[^0-9]/g, '')"
                  class="form-control input-style" :placeholder="$t('addAd.residencyNumber')">
                <div class="error-feedback" v-if="V$.identityNumber.$error">
                  {{ validateMessage }}
                </div>
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-12 col-md-6">
                <label for="" class="p-content" >{{$t('addAd.dateBirth')}}</label>
                <datepicker class="form-control input-style mouse-hand"
                  v-model="birthDate"
                  :clearable="true"
                  :placeholder="$t('addAd.datePlaceholder')"
                  :upperLimit="maxDate"
                />
              <div class="error-feedback" v-if="V$.birthDate.$error">
                {{ validateMessage }}
              </div>
                <!-- <input type="text" v-model="birthDate" class="form-control input-style" :placeholder="$t('addAd.datePlaceholder')"> -->
              </div>
              <div class="col-12 col-md-6">
                <label for="" class="p-content" >{{$t('addAd.Owner_Agent_MobileNumber')}}</label>
                <input type="text" v-model="mobile" maxlength="10" @input="mobile = mobile.replace(/[^0-9]/g, '')"
                  class="form-control input-style" :placeholder="$t('addAd.placeholdermobileNumber')">
                <div class="error-feedback" v-if="V$.mobile.$error">
                  {{ validateMessage }}
                </div>
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-12 col-md-6">
                <label for="" class="p-content" >{{$t('PropertyAge')}}</label>
                <!-- <input type="text" v-model="ageId" maxlength="10" @input="ageId = ageId.replace(/[^0-9]/g, '')"
                  class="form-control input-style"> -->
                <select v-model="ageId" class="form-select input-style" aria-label="Default select example">
                  <option :value="$t('addAd.choose_Property_Age')" >{{$t('addAd.choose_Property_Age')}}</option>
                  <option v-for="(val,indexage) in agesList" :key="indexage" :value="val.id">{{val.name}}</option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label for="" class="p-content" >{{$t('addAd.roomsCount')}}</label>
                <input type="text" v-model="roomsCount" maxlength="10" @input="roomsCount = roomsCount.replace(/[^0-9]/g, '')"
                  class="form-control input-style" :placeholder="$t('addAd.roomsCount_holder')">
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-12 col-md-6">
                <label for="" class="p-content" >{{$t('addAd.price')}}</label>
                <input type="text" v-model="price" maxlength="10" @input="price = price.replace(/[^0-9]/g, '')"
                  class="form-control input-style" :placeholder="$t('addAd.propertyValue')">
                <div class="error-feedback" v-if="V$.price.$error">
                  {{ validateMessage }}
                </div>
              </div>
              <div class="col-12 col-md-6">
                <label for="" class="p-content" >{{$t('addAd.typeAdvertisement')}}</label>
                <div class="row typeAdvertisement">
                  <div class="col-6">
                    <div class="input-style">
                      <label class="form-check-label d-block" for="sale">
                      <input class="form-check-input" value="sale" v-model="adType" type="radio" name="radioDefault" id="sale">
                        {{$t('addAd.sale')}}
                      </label>
                    </div>
                  </div>
                  <div class="col-6 input-style">
                    <label class="form-check-label d-block" for="rent">
                    <input class="form-check-input" v-model="adType"  value="rent" type="radio" name="radioDefault" id="rent">
                      {{$t('addAd.rent')}}
                    </label>
                  </div>
                  <div class="error-feedback" v-if="V$.adType.$error">
                    {{ validateMessage }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row pt-3" v-if="!isFree">
              <div class="col-12 position-R">
                <label class="p-content">{{$t('maintenances.title_9')}}</label>
                <input type="text" id="discount" class="form-control input-style" v-model="discount">
                <span class="discount_Photo" @click.prevent="checkDiscount">{{$t('maintenances.title_10')}}</span>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-12">
                <label class="p-content">{{$t('addingNotes')}}</label>
                <textarea rows="4" v-model="notes" class="form-control br-radius"></textarea>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-12">
                <label class="p-content">{{$t('addAd.attachCopy')}}</label>
                <div class="uploadFile">
                  <label class="mouse-hand" for="upload" >
                    <img src="/assets/images/icons/file-up.png" class="max-28 py-2"  alt=""> <br>
                    <input type="file" id="upload" @change="uploadImage($event.target.files)" class="input-style d-none form-control" multiple>
                    <div class="font-color-3E font-12">{{$t('addAd.certifiedDocument')}}</div>
                    <div class="font-color-AB py-2">{{$t('addAd.supported_Fileformats')}}</div>
                  </label>
                </div>
              </div>
            </div>
            <div class="row pt-4 justify-content-center">
              <div class="col-10 d-block d-lg-none mb-2">
                <div class="text-center" v-if="isLoading"> <loader /> </div>
                <div v-else class="btn-green" @click.prevent="popupPaymentOrder">{{$t('addAd.paymentSubmission')}}</div>
              </div>
              <div class="col content-center">
                <a href="https://wa.me/+966920016962?text= السلام عليكم أود التواصل مع أخصائى خدمة العملاء للاطلاع علي خدماتكم العقارية ومعرفة الخيارات المتاحة للتعاون وملاءمتها لاحتياجى الحالى. شكرًا لكم"  target="_blank">
                  <div>
                    <span>{{$t('addAd.encounteredProblem')}}</span>
                    <span class="font-color-3E mx-2 underline">{{$t('addAd.contactUs')}}</span>
                  </div>
                </a>
              </div>
              <div class="col-auto d-none d-lg-block">
                <div class="text-center" v-if="isLoading"> <loader /> </div>
                <div v-else class="btn-green" @click.prevent="popupPaymentOrder">{{$t('addAd.paymentSubmission')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- begin:modal-payment -->
    <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="documentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                {{$t('wallet.payment')}}
              </div>
              <div class="col-auto mouse-hand" id="closeModal" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="py-2 gray-color">{{$t('wallet.choosePayment_Method')}}</div>

            <div class="row py-3" v-if="costPrice">
              <label class="almarai-bold mb-2">{{$t('wallet.cost')}}</label>
              <div class="col-12">
                <div class="d-flex input-style">
                  <span class="gray-color almarai-bold">{{$t('wallet.cost')}}</span>
                  <div class="direction">
                    <span class="mx-2 gray-color almarai-bold">{{costPrice}}</span>
                    <span>
                      <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <label class="almarai-bold pt-2">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'online')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate" type="radio" value="online" name="radioSelected" id="visa">
                    <div class="row">
                      <div class="col-auto">
                        <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                      </div>
                      <div class="col p-0">
                        <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                        <div class="bankCard">{{$t('wallet.bankCard')}}</div>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'wallet')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioSelected" id="radioDefault1">
                    <div class="row">
                      <div class="col-auto">
                        <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                      </div>
                      <div class="col p-0">
                        <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                        <div class="bankCard">{{$t('wallet.appWallet')}}</div>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div v-if="isLoading" class="text-center">
                <loader />
              </div>
              <div v-else class="col-12 text-center">
                <button @click.prevent="paymentMethod" class="form-control btn-green almarai-bold">{{$t('maintenanceDetails.title_5')}} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:modal-payment -->

    <!--begin:Charge your wallet -->
      <chargeWallet />
    <!--end:Charge your wallet -->

    <!--begin:popup wallet balance -->
    <div class="modal bg-color-B" tabindex="-1" id="popup_WalletBalance">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row btn-closed">
              <div class="col-auto mouse-hand" @click.prevent="closeForm" id="closeModal" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>
            <h6 class="modal-title text-center almarai-bold">{{$t('walletPaymentConfirmation')}}</h6>
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-start">
                {{USER_WALLET_BALANCE}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="newDiscount === null">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                {{costPrice}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="newDiscount !== null">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                <del>{{costPrice}}</del>
              </div>
            </div>

            <div class="row" v-if="newDiscount !== null || discountPercentage">
              <div class="col-auto almarai-bold content-center">{{$t('priceDiscount')}}</div>
              <div class="col text-start">
                {{newDiscount}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-start">
                {{totalCost}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="isLoading" class="text-center">
                <loader />
              </div>
              <div v-else class="col-12 col-md-6 text-center" @click.prevent="adLicenseReq">
                <div class="btn-green">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:popup wallet balance -->

    <!-- begin:form Success -->
    <div class="modal bg-modal" tabindex="-1" id="formSuccess">
      <div class="modal-dialog modal-Max320">
        <div class="modal-content">
          <div class="modal-body">
            <!-- <div class="row">
              <div class="col-auto mouse-hand" id="closeForm" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div> -->
            <div class="row justify-content-center py-2">
              <div class="col-12 text-center">
                <img src="/assets/images/icons/tick-circle-gold.png" class="circleGold" alt="">
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="font-24 almarai-bold text-center mb-1">{{$t('formSuccess.title_1')}}</div>
                <div class="text-center fonttext-14 gray-color almarai-regular">{{$t('formSuccess.we_willContact')}}</div>
              </div>
            </div>
            <div class="row py-3">
              <router-link to="/">
                <div class="col-12 mouse-hand" id="back">
                  <div class="btn-green almarai-bold text-center">{{$t('formSuccess.title_4')}}</div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:form Success -->

    <!-- Modal:begin couponPopup -->
    <button type="button" id="coupon" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal">
    </button>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content br-radius-24">
          <div class="modal-body text-center">
            <div><img src="/assets/images/icons/new-success.png" class="w-25" alt=""></div>
            <h6 v-if="value" class="pt-3"><span class="ms-1">{{$t('maintenances.title_9')}}</span> {{value.amount}} {{(value.discountType == "percentage" )? '%' : $t('maintenances.title_22') }}</h6>
            <p>{{$t('maintenances.title_20')}}</p>
            <div class="row justify-content-center">
              <div class="col-12 col-md-7">
                <div type="button" class="btn-green" data-bs-dismiss="modal">{{$t('maintenances.title_21')}}</div>
              </div>
            </div>
          </div>            
        </div>
      </div>
    </div>
    <!-- end:couponPopup -->
  </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Datepicker from 'vue3-datepicker';
import { mapGetters } from "vuex";
export default {
  name: "advertisingLicense",
  setup () {
    return { V$: useVuelidate() }
  },
  data(){
    return{
      hasError: false,
      message: "",
      errorNumber: null,
      isLoading: false,
      deedNumber: null,
      identityNumber: null,
      birthDate: '',
      mobile: '',
      adType: '',
      price: "",
      paymentGate: "",
      attachments: [],
      maxDate: null,
      validateMessage: this.$t('validateMessage'),
      isFree: false,
      costPrice: null,
      totalCost: null,
      loading: false,
      userLang: 'ar',
      notes: "",
      roomsCount: 0,
      ageId: null,
      discount: null,
      newDiscount: null,
      value: {},
      agesList: [],
      discountPercentage: "",
    }
  },
  components: {
    Datepicker,
  },
  computed:{
    ...mapGetters(['USER_WALLET_BALANCE'])
  },
  validations(){
    return {
      deedNumber: {required},
      identityNumber: {required},
      birthDate: {required},
      mobile: {required},
      adType: {required},
      price: {required},
    }
  },
  methods: {
    getDatainit(){
      this.hasError = false;
      this.loading = true;
      this.$http.get('/api/adLicenseReq/init').then(res => {
        // console.log(res);
        this.isFree = res.data.isFree;
        this.costPrice = res.data.price;
        this.agesList = res.data.agesList;

        setTimeout( ()=> {
          this.totalCost = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.costPrice);
        },200)
        this.loading = false;
      }).catch(err => {
        console.log(err);
        this.loading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },

    async popupPaymentOrder(){
      this.hasError = false;
      const valid = await this.V$.$validate();

      if(this.deedNumber && (this.deedNumber.trim().length < 10 || this.deedNumber.trim().length > 16)){
        this.message =  this.$t('deedNumber');
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }

      if(this.identityNumber && ((this.identityNumber.substring(0, 1) != 1 && this.identityNumber.substring(0, 1) != 2)  || `${this.identityNumber}`.length !=10)){
        this.message =  this.$t("identityNumber");
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }
      if(this.mobile.trim().length != 10 || !this.mobile.startsWith('05')){
        this.message = this.$t('incorrectMobile');
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }
      if(!valid){
        window.scroll(0,0);
        return false;
      }
      if(this.isFree){
        this.adLicenseReq();
        return false;
      }
      if(this.value.discountType == 'percentage' && this.value.amount == 100){
        this.adLicenseReq();
        return false;
      }
      if(this.costPrice){
        document.getElementById('selectPayment').click();
      }

    },

    uploadImage(files){
      this.attachments = [...files];
    },

    paymentMethod(){
      if(this.paymentGate == 'online'){
        this.adLicenseReq();
      }else{
        this.showPopup();
      }
    },

    showPopup(){
      document.getElementById('selectPayment').click();
      if(this.costPrice > this.USER_WALLET_BALANCE){
        document.getElementById('chargeWallet').style.display = 'block';
      }else{
        this.totalCost = this.USER_WALLET_BALANCE - this.costPrice;
        document.getElementById('popup_WalletBalance').style.display = 'block';
      }
    },

    closeForm(){
      document.getElementById('popup_WalletBalance').style.display = 'none';
    },


    adLicenseReq(){
      this.hasError =false;
      const formData = new FormData();
      formData.append("deedNumber", this.deedNumber);
      formData.append("identityNumber", this.identityNumber);
      formData.append("birthDate", this.birthDate);
      formData.append("adType", this.adType);
      formData.append("price", this.price);
      formData.append("mobile", this.mobile);
      formData.append("attachments", this.attachments);
      formData.append("paymentGate", this.paymentGate);
      formData.append("ageId", parseInt(this.ageId));
      formData.append("roomsCount", parseInt(this.roomsCount));
      formData.append("notes", this.notes);

      if(this.discount){
        formData.append('coupon', this.discount);
      }
      this.$http.post('/api/adLicenseReq/create',formData).then(res => {
        if(res.data.paymentUrl){
          window.location.href = res.data.paymentUrl;
        }else{
          if(this.paymentGate == 'wallet'){
            document.getElementById('popup_WalletBalance').style.display = 'none';
          }
          document.getElementById('formSuccess').style.display = 'block';
        } 
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        document.getElementById('popup_WalletBalance').style.display = 'none';
        window.scrollTo({top:0, behavior:'smooth'});
      })
    },

    checkDiscount(){
      this.hasError = false;
      this.$http.post("/api/coupons/available",{
        coupon: this.discount,
        modelName: 'adLicense',
      }).then(res => {
        // console.log(res);
        this.value = res.data.row;
        this.discountPercentage = res.data.row.discountType;
        document.getElementById('coupon').click();
        if(this.value.discountType == 'percentage'){
          this.newDiscount = this.costPrice - ((this.costPrice * this.value.amount) /100);
          this.totalCost = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.newDiscount);
        }else{
          this.newDiscount = this.costPrice - this.value.amount;
          this.totalCost = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.newDiscount);
        }
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

  },
  created(){
    this.getDatainit();
    this.maxDate = new Date();
    this.maxDate.setFullYear(this.maxDate.getFullYear() - 10);
    // this.birthDate = new Date();
    // this.birthDate.setFullYear(this.birthDate.getFullYear() -20);
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior:'smooth'});
  }
}
</script>